import { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { api, euro } from "../../lib/api";
import { Link } from "react-router-dom";

export default function FinancialTrends({ sites }) {
 const [rows,setRows]=useState([]),[failed,setFailed]=useState([]),[loading,setLoading]=useState(true);
 useEffect(()=>{
  let alive=true;setLoading(true);
  Promise.allSettled(sites.map(s=>api.getFinancialTrends(s.id))).then(results=>{
   if(!alive)return;
   const failures=[];
   const combined={};
   results.forEach((r,i)=>{
    if(r.status!=="fulfilled"){failures.push(sites[i].name||sites[i].id);return;}
    (r.value.months||[]).forEach(x=>{
     const row=combined[x.month]||(combined[x.month]={month:x.month,billed:0,collected:0});
     row.billed+=Number(x.billed)||0;row.collected+=Number(x.collected)||0;
    });
   });
   let outstanding=0;
   setRows(Object.values(combined).sort((a,b)=>a.month.localeCompare(b.month)).map(r=>{
    outstanding+=r.billed-r.collected;
    return {...r,outstanding:Math.round(outstanding*100)/100};
   }));
   setFailed(failures);setLoading(false);
  });
  return ()=>{alive=false};
 },[sites]);
 const last=rows[rows.length-1];
 return <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm space-y-4" data-testid="financial-trends">
  <div className="flex justify-between gap-3 flex-wrap items-start">
   <div><p className="text-xs font-bold tracking-widest text-orange-600 uppercase">Andamenti finanziari</p><h2 className="text-xl sm:text-2xl font-extrabold mt-1 text-slate-900">Fatturazione e flussi di incasso</h2><p className="text-xs text-slate-500 mt-1">Serie mensile dalle fatture clienti e dagli incassi associati registrati.</p></div>
   <Link to="/contabilita-cantieri" className="text-sm font-semibold text-orange-700 hover:underline">Gestisci fatture →</Link>
  </div>
  {failed.length>0&&<p role="alert" className="text-sm rounded-lg bg-amber-50 p-3 text-amber-900">Dati parziali: {failed.join(", ")}</p>}
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
   <div className="rounded-lg bg-slate-50 p-3"><div className="text-xs text-slate-500">Mesi con movimenti</div><div className="text-xl font-bold mt-1">{loading?"…":rows.length}</div></div>
   <div className="rounded-lg bg-slate-50 p-3"><div className="text-xs text-slate-500">Crediti residui registrati</div><div className="text-xl font-bold mt-1">{loading?"…":last?euro(last.outstanding):"n.d."}</div></div>
   <div className="rounded-lg bg-slate-50 p-3 col-span-2 sm:col-span-1"><div className="text-xs text-slate-500">Ultimo mese registrato</div><div className="text-xl font-bold mt-1">{loading?"…":last?.month||"n.d."}</div></div>
  </div>
  {rows.length?<div className="h-80 w-full"><ResponsiveContainer width="100%" height="100%"><ComposedChart data={rows} margin={{top:10,right:12,left:4,bottom:4}}>
   <CartesianGrid strokeDasharray="3 3" vertical={false}/><XAxis dataKey="month" tick={{fontSize:11}}/><YAxis tickFormatter={v=>Math.abs(v)>=1000?Math.round(v/1000)+"k":v} tick={{fontSize:10}}/><Tooltip formatter={v=>euro(v)}/><Legend/>
   <Bar dataKey="billed" name="Fatturato del mese" fill="#2563eb" radius={[4,4,0,0]}/>
   <Bar dataKey="collected" name="Incassato registrato" fill="#059669" radius={[4,4,0,0]}/>
   <Line type="monotone" dataKey="outstanding" name="Crediti residui cumulati" stroke="#e87924" strokeWidth={3} dot={false}/>
  </ComposedChart></ResponsiveContainer></div>:<p className="py-12 text-center text-sm text-slate-500">{loading?"Caricamento…":"Nessuna fattura o pagamento datato ancora disponibile."}</p>}
  <p className="text-xs text-slate-500">I movimenti sono aggregati per mese sulla data registrata. Incassi dichiarati, non verificati con la banca. Non rappresenta un rendiconto finanziario completo e non include pagamenti fornitori.</p>
 </section>;
}
